import { render, staticRenderFns } from "./Personne.vue?vue&type=template&id=58d04f1b&scoped=true&"
import script from "./Personne.vue?vue&type=script&lang=js&"
export * from "./Personne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d04f1b",
  null
  
)

export default component.exports